import { Routes, RouterModule } from '@angular/router';
import { PublicLayoutComponent } from './_layout/public-layout/public-layout.component';
import { PrivateLayoutComponent } from './_layout/private-layout/private-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { RegisterComponent } from './register';
import { LoginComponent } from './login';
import { ChangelogComponent } from './changelog/changelog.component';
import { ViewquotationComponent } from './content/pages/quotation/viewquotation/viewquotation.component';
import { ViewBillComponent } from './content/pages/bill/view-bill/view-bill.component';
import { ViewrentinvoiceComponent } from './content/pages/rentandrepair/viewrentinvoice/viewrentinvoice.component';
import { ViewchallanComponent } from './content/pages/challan/viewchallan/viewchallan.component';

const appRoutes: Routes = [
  // Public layout
  {
    path: '',
    component: PublicLayoutComponent,
    children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      { path: '', component: LoginComponent }
    ]
  },
  // Private layout
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'register', component: RegisterComponent },
      { path: 'login', component: LoginComponent },
      // { path: 'forgot', component: ForgotpasswordComponent },
      { path: 'viewquotation', component: ViewquotationComponent },
      { path: 'viewbill', component: ViewBillComponent },
      { path: 'viewrentbill', component: ViewrentinvoiceComponent },
      { path: 'viewchallan', component: ViewchallanComponent },
      { path: '', component: LoginComponent }
    ],
  },// Private layout`
  {
    path: '',
    component: PrivateLayoutComponent,
    children: [
      { path: 'logout', component: LoginComponent, canActivate: [AuthGuard] },
      // { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },

      {
        path: 'employee', loadChildren: () => import('../app/content/pages/employee/employee.module').then(m => m.EmployeeModule),
        canActivate: [AuthGuard]
      },

      {
        path: 'report', loadChildren: () => import('../app/content/pages/report/report.module').then(m => m.ReportModule),
        canActivate: [AuthGuard]
      },

      {
        path: 'customer', loadChildren: () => import('../app/content/pages/customer/customer.module').then(m => m.CustomerModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'quotation', loadChildren: () => import('../app/content/pages/quotation/quotation.module').then(m => m.QuotationModule),
        canActivate: [AuthGuard]
      },

      // {
      //   path: 'calendar', loadChildren: () => import('../app/content/pages/calender/calender.module').then(m => m.CalenderModule),
      //   canActivate: [AuthGuard]
      // },

      {
        path: 'profile', loadChildren: () => import('../app/content/pages/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [AuthGuard]
      },

      {
        path: 'challan', loadChildren: () => import('../app/content/pages/challan/challan.module').then(m => m.ChallanModule),
        canActivate: [AuthGuard]
      },

      {
        path: 'inventory', loadChildren: () => import('../app/content/pages/inventory/inventory.module').then(m => m.InventoryModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'bill', loadChildren: () => import('../app/content/pages/bill/bill.module').then(m => m.BillModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'stock', loadChildren: () => import('../app/content/pages/stock/stock.module').then(m => m.StockModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'admin', loadChildren: () => import('../app/content/pages/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'masterdata', loadChildren: () => import('../app/content/pages/masterdata/masterdata.module').then(m => m.MasterdataModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'dashboard', loadChildren: () => import('../app/content/dashboard/dashboard.module').then(m => m.DashboardModule),
        canActivate: [AuthGuard]
      },
      {
        path: 'rentinvoice', loadChildren: () => import('../app/content/pages/rentandrepair/rentandrepair.module').then(m => m.RentandrepairModule),

        canActivate: [AuthGuard]
      },
      {
        path: 'documents', loadChildren: () => import('../app/content/pages/documents/documents.module').then(m => m.DocumentsModule),

        canActivate: [AuthGuard]
      },
      {
        path: 'account', loadChildren: () => import('../app/content/pages/account/account.module').then(m => m.AccountModule),
        canActivate: [AuthGuard]
      }
    ],
  },
  // otherwise redirect to home
  { path: '**', redirectTo: 'dashboard/newdashboard' }
];

export const routing = RouterModule.forRoot(appRoutes, { scrollOffset: [0, 0], scrollPositionRestoration: 'top' });
